import { useQuery } from "react-query";
import { useSelector } from "react-redux";
import useDepartmentSelector from "../../../TCPForms/hooks/useDepartmentSelector";
import { toTitleCase } from "../../../../../utils";

const getMapSubmissionData = (t, id = null) => {
  const tenantId = Digit.ULBService.getStateId() || 'up';
  const edcrData = Digit.SessionStorage.get("EDCR_CREATE")?.[0];
  const planDetail = edcrData?.planDetail;
  const isRescrutiny = planDetail?.applicationScrutinyType || false
  const regulatedObj = edcrData?.planDetail?.reportOutput?.scrutinyDetails?.filter((e) => e.key === 'Block_1_Side Setback')
  const { isSuccess: isMdmsSuccess, data: mdmsData } = Digit.Hooks.obps.useMDMS(tenantId, "BPA", ["RiskTypeComputation"]);
  const calcRiskType = isMdmsSuccess && (
    Digit.Utils.obps.calculateRiskType(
      mdmsData?.BPA?.RiskTypeComputation,
      planDetail?.plot?.area,
      planDetail?.blocks
    )
  );
  const riskType = calcRiskType ? t(`WF_BPA_${calcRiskType}`) : null;
  const scrutinyDetails = Digit.SessionStorage.get("ScrutinyDetails");
  const blocks = planDetail?.blocks?.[0];
  const setBacksData = blocks?.setBacks?.[0];
  const planInformation = planDetail?.planInformation;


  if (id && !isRescrutiny) { // Fetch application data for edit flow
    const fetchApplicationData = async () => {
      return await Digit.OBPSService.BPASearch(tenantId, { applicationId: id, isEmployee: false })
    }
    const { data, isLoading: isAppDataLoading, isSuccess } = useQuery({ queryKey: [id], queryFn: fetchApplicationData, enabled: isMdmsSuccess });
    const applicationData = isSuccess && data?.BPA?.[0];
    return { applicationData, isAppDataLoading }
  }
  else if (id && isRescrutiny) {
    console.log(isRescrutiny, "isRescrutinyyyyyy")    
    const fetchApplicationData = async () => {
      return await Digit.OBPSService.BPASearch(tenantId, { applicationId: id, isEmployee: false })
    }
    const { data, isLoading: isAppDataLoading, isSuccess } = useQuery({ queryKey: [id], queryFn: fetchApplicationData, enabled: isMdmsSuccess });
    let applicationData = isSuccess && data?.BPA?.[0];
     applicationData = {
      ...applicationData,
      applicationDate: edcrData?.applicationDate || null,
      occupancy: planInformation?.occupancy || null,
      edcrNumber: edcrData?.edcrNumber || null,
      totalBuildUpArea: planDetail?.virtualBuilding?.totalBuitUpArea,
      totalProposedArea: planDetail?.virtualBuilding?.totalProposedArea,
      totalExistingBuiltUpArea: planDetail?.virtualBuilding?.totalExistingBuiltUpArea,
      maximumPermissibleGroundCoverage: planDetail?.virtualBuilding?.totalCoverageArea?.toFixed(2) || null,
      typeofArea: toTitleCase(planInformation?.landUseZone),
      propertyType: toTitleCase(planInformation?.applicantPropertyType || planDetail?.planInfoProperties?.PROPERTY_TYPE),
      proposal: planInformation?.proposalSubmittedFor || null,
      revenueVillageMohal: planInformation?.mauza || null,
      khataNo: planInformation?.khataNo || null,
      khatauniNo: planInformation?.khatauniNo || null,
      plotArea: planInformation?.plotArea || planDetail?.plot?.area || 0,
      totalPlotArea: planInformation?.plotArea || 0,
      blocks: planDetail?.blocks || null,
      noOfBlocks: planDetail?.blocks?.length || 0,
      premiumFAR: planDetail?.virtualBuilding?.premiumFarArea || 0,
      demolitionArea: planInformation?.demolitionArea || null,
      parkingArea: planDetail?.parkingDetails?.overAllParkingArea || 0,
      parkingFloorNo: planDetail?.parkingDetails?.parkingFloorNo || 0,
      activeTab: Digit?.SessionStorage.get("MS_CURRENT_TAB") || 0,
      riskType: edcrData?.riskType,
      //planDetail: planDetail,
      planReport: edcrData?.planReport,
      updatedDxfFile: edcrData?.updatedDxfFile,
      dxfFile: edcrData?.dxfFile,
      natureOfConstruction: edcrData?.natureOfConstruction,
      proposalType: edcrData?.proposalType,
      sanctionDate: edcrData?.sanctionDate,
      sanctionNumber: edcrData?.sanctionNumber,
      noOfPlots: edcrData?.noOfPlots,
      plotNumbers: edcrData?.plotNumbers,
      district: edcrData?.district,
      sectorNoPlotNo: edcrData?.sectorNoPlotNo,
      tehsil: edcrData?.tehsil,
      revenueVillage: edcrData?.revenueVillage,
      landMark: edcrData?.landMark,
      schemeName: edcrData?.schemeName,
      buildingClassification: edcrData?.buildingClassification,
      otherbuildingClass: edcrData?.otherbuildingClass,
      planOn: edcrData?.planOn,
      buildingHeight: edcrData?.buildingHeight,
      projectType: edcrData?.projectType,
      isRevised: edcrData?.isRevised,
      prevFileNo: edcrData?.prevFileNo,
      isSpecialProject: edcrData?.isSpecialProject,
      typeOfProject: edcrData?.typeOfProject,
      plotSubdivided: edcrData?.plotSubdivided,
      plotNo: edcrData?.plotNo,
      needCompounding: edcrData?.needCompounding,
      plotLeaseHold: edcrData?.plotLeaseHold,
      isApprovedLayout: edcrData?.isApprovedLayout,
      isSpecialGroundCoverage: edcrData?.isSpecialGroundCoverage,
      isSpecialFAR: edcrData?.isSpecialFAR,
      constructionType: edcrData?.constructionType,
      layoutsanctionNumber: edcrData?.layoutsanctionNumber,
      layoutsanctionDate: edcrData?.layoutsanctionDate,
      groundCoverage: edcrData?.groundCoverages,
      far: edcrData?.fars,
      isSetbackRequired: edcrData?.isSetbackRequired,
      setbackFronts: edcrData?.previousSetbackFront,
      setbackRears: edcrData?.previousSetbackRear,
      setbackSide1: edcrData?.previousSetbackSide1,
      setbackSide2: edcrData?.previousSetbackSide2,
      zoneType: edcrData?.zoneType,
      isMetroCity: edcrData?.isMetroCity,
      subZoneType: edcrData?.subZoneType,
      primaryUse: edcrData?.primaryUse,
      activityProposed: edcrData?.activityProposed,
      communityParking: edcrData?.communityParking,
      anyotherCondition: edcrData?.anyotherCondition,
      khasraNo: edcrData?.khasraNo,
      sectorNo: edcrData?.sectorNo,
    }
    return { applicationData, isAppDataLoading }
  }



  // Create Application data object for create flow
  const applicationType = "FORM_MAP";
  const userInfo = Digit.UserService.getUser();
  const { documents } = useSelector(state => state.form12);
  const [, applicationFlow] = useDepartmentSelector();


  const applicantName = toTitleCase(scrutinyDetails?.applicantName || planInformation?.applicantName);

  const applicationData = {
    tenantId,
    applicationNo: edcrData?.applicationNumber || null,
    applicationDate: edcrData?.applicationDate || null,
    applicationSubType: edcrData?.applicationSubType || null,
    occupancy: planInformation?.occupancy || null,
    edcrNumber: edcrData?.edcrNumber || null,
    totalBuildUpArea: planDetail?.virtualBuilding?.totalBuitUpArea,
    totalProposedArea: planDetail?.virtualBuilding?.totalProposedArea,
    totalExistingBuiltUpArea: planDetail?.virtualBuilding?.totalExistingBuiltUpArea,
    maximumPermissibleGroundCoverage: planDetail?.virtualBuilding?.totalCoverageArea?.toFixed(2) || null,
    typeofArea: toTitleCase(planInformation?.landUseZone),
    propertyType: toTitleCase(planInformation?.applicantPropertyType || planDetail?.planInfoProperties?.PROPERTY_TYPE),
    proposal: planInformation?.proposalSubmittedFor || null,
    revenueVillageMohal: planInformation?.mauza || null,
    khataNo: planInformation?.khataNo || null,
    khatauniNo: planInformation?.khatauniNo || null,
    plotArea: planInformation?.plotArea || planDetail?.plot?.area || 0,
    plotAreaDoc: edcrData?.plotAreaDoc,
    plotAreaPos: edcrData?.plotAreaPossession,
    siteAddress: edcrData?.landAddress,
    totalPlotArea: planInformation?.plotArea || 0,
    blocks: planDetail?.blocks || null,
    noOfBlocks: planDetail?.blocks?.length || 0,
    premiumFAR: planDetail?.virtualBuilding?.premiumFarArea || 0,
    demolitionArea: planInformation?.demolitionArea || null,
    parkingArea: planDetail?.parkingDetails?.overAllParkingArea || 0,
    parkingFloorNo: planDetail?.parkingDetails?.parkingFloorNo || 0,
    activeTab: Digit?.SessionStorage.get("MS_CURRENT_TAB") || 0,
    riskType: edcrData?.riskType,
    //planDetail: planDetail,
    applicationType,
    department: applicationFlow,
    feeType: "ApplicationFee",
    tod: {
      orientDevelopment: null,
      convertedLandUseinTOD: null,
    },
    planReport: edcrData?.planReport,
    updatedDxfFile: edcrData?.updatedDxfFile,
    dxfFile: edcrData?.dxfFile,
    workflow: { action: "INITIATE", assignes: null },
    landInfo: {
      owners: null,
      address: {
        city: planInformation?.district,
        locality: { code: 'Lucknow' },
        region: null,
        doorNo: null,
        areaType: scrutinyDetails?.areaType,
      },
      tenantId
    },
    professionaldetails: {
      name: userInfo?.info?.name,
      mobileNumber: userInfo?.info?.mobileNumber,
      emailId: userInfo?.info?.emailId
    },
    landAreaDetails: {
      city: scrutinyDetails?.city?.name || toTitleCase(planInformation?.correspondenceAddress?.district) || null,
      locality: {
        name: scrutinyDetails?.locality?.name || toTitleCase(planInformation?.correspondenceAddress?.tehsil) || null,
      },
      village: {
        name: scrutinyDetails?.village?.name || toTitleCase(planInformation?.correspondenceAddress?.town) || null,
      },
      areaType: scrutinyDetails?.areaType
    },
    businessService: applicationFlow === 'DA' ? 'BPA_MAPSUB_DA' : 'BPA_MAPSUB_AVP',
    documents,
    natureOfConstruction: edcrData?.natureOfConstruction,
    proposalType: edcrData?.proposalType,
    sanctionDate: edcrData?.sanctionDate,
    sanctionNumber: edcrData?.sanctionNumber,
    noOfPlots: edcrData?.noOfPlots,
    plotNumbers: edcrData?.plotNumbers,
    district: edcrData?.district,
    sectorNoPlotNo: edcrData?.sectorNoPlotNo,
    tehsil: edcrData?.tehsil,
    revenueVillage: edcrData?.revenueVillage,
    landMark: edcrData?.landMark,
    schemeName: edcrData?.schemeName,
    buildingClassification: edcrData?.buildingClassification,
    otherbuildingClass: edcrData?.otherbuildingClass,
    planOn: edcrData?.planOn,
    buildingHeight: edcrData?.buildingHeight,
    projectType: edcrData?.projectType,
    isRevised: edcrData?.isRevised,
    prevFileNo: edcrData?.prevFileNo,
    isSpecialProject: edcrData?.isSpecialProject,
    typeOfProject: edcrData?.typeOfProject,
    plotSubdivided: edcrData?.plotSubdivided,
    plotNo: edcrData?.plotNo,
    needCompounding: edcrData?.needCompounding,
    plotLeaseHold: edcrData?.plotLeaseHold,
    isApprovedLayout: edcrData?.isApprovedLayout,
    isSpecialGroundCoverage: edcrData?.isSpecialGroundCoverage,
    isSpecialFAR: edcrData?.isSpecialFAR,
    constructionType: edcrData?.constructionType,
    layoutsanctionNumber: edcrData?.layoutsanctionNumber,
    layoutsanctionDate: edcrData?.layoutsanctionDate,
    groundCoverage: edcrData?.groundCoverages,
    far: edcrData?.fars,
    isSetbackRequired: edcrData?.isSetbackRequired,
    setbackFronts: edcrData?.previousSetbackFront,
    setbackRears: edcrData?.previousSetbackRear,
    setbackSide1: edcrData?.previousSetbackSide1,
    setbackSide2: edcrData?.previousSetbackSide2,
    zoneType: edcrData?.zoneType,
    isMetroCity: edcrData?.isMetroCity,
    subZoneType: edcrData?.subZoneType,
    primaryUse: edcrData?.primaryUse,
    activityProposed: edcrData?.activityProposed,
    communityParking: edcrData?.communityParking,
    anyotherCondition: edcrData?.anyotherCondition,
    khasraNo: edcrData?.khasraNo,
    sectorNo: edcrData?.sectorNo,
    uiFlow: { flow: 'Form12' },
  }

  return { applicationData, isAppDataLoading: false }
}

export default getMapSubmissionData;
